const currentYear = new Date().getFullYear()
const currentMonth = new Date().getMonth()

export const currentFinancialYear = () => {
  const year = currentMonth > 5 ? currentYear : currentYear - 1

  return {
    lastYear: (year - 1) + '-' + year,
    yearBeforeLast: (year - 2) + '-' + (year - 1)
  }
}

export const financialYear = () => {
  const year = currentYear - 1

  return {
    lastYear: (year - 1) + '-' + year,
    yearBeforeLast: (year - 2) + '-' + (year - 1)
  }
}
